// Like countryInt = "en-IN" & currency = "INR"
// Like countryInt = "en-US" & currency = "USD"
let countryInt = 'en-IN';
let currency = 'INR';

let _companySession = localStorage.getItem('vs_UserCompanySession');
if(_companySession!=undefined || _companySession!=null)
{
    _companySession = JSON.parse(_companySession);
    countryInt = 'en-'+_companySession.country_short;
    currency = _companySession.currency_code;
}

export const numberFormat = (value) =>{
    if(value!=undefined && value!=null)
    {
        // Allow negative values to be displayed (for net totals like Sales - Credit Notes)
        value = parseFloat(value) || 0;
        return new Intl.NumberFormat(countryInt, {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    }
    else
    {
        return '';
    }
}
    
